import React from 'react'

function Whatsapp() {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.44 3.56C10.52.6 6.6-.28 3.56 1.56.6 3.4-.36 7.4 1.56 10.36l.16.24-.64 2.4 2.4-.64.24.16c1.04.56 2.16.88 3.28.88 1.2 0 2.4-.32 3.44-.96 2.96-1.92 3.84-5.84 2-8.88zm-1.68 6.16c-.32.48-.72.8-1.28.88-.32 0-.72.16-2.32-.48-1.36-.64-2.48-1.68-3.28-2.88-.48-.56-.72-1.28-.8-2 0-.64.24-1.2.64-1.6.16-.16.32-.24.48-.24h.4c.16 0 .32 0 .4.32.16.4.56 1.36.56 1.44.08.08.08.24 0 .32.08.16 0 .32-.08.4-.08.08-.16.24-.24.32-.16.08-.24.24-.16.4.32.48.72.96 1.12 1.36.48.4.96.72 1.52.96.16.08.32.08.4-.08.08-.16.48-.56.64-.72.16-.16.24-.16.4-.08l1.28.64c.16.08.32.16.4.24.08.24.08.56-.08.8z"
        fill="#737373"
      />
    </svg>
  )
}

export default React.memo(Whatsapp)
